import React from 'react'
import { Icon } from '@toctoc/design-system';
import styles from "./Breadcrumbs.module.scss";
import { getDataAttributes } from '@/utils/object';

interface IBreadcrumb extends Partial<HTMLElement>{
	urlBase?: string;
	tipoOperacionFamilia?: string;
	tipoPropiedadFamilia?: string;
	regionPath?: string;
	comunaPath?: string;
	region?: string;
	comuna?: string;
	chain?: string;
	isMobile?: boolean;
}

interface IBreadcrumbItem {
	link?: string;
	text?: string;
}

export const Breadcrumbs = ({ urlBase, tipoOperacionFamilia, tipoPropiedadFamilia, region, comuna, isMobile, comunaPath, regionPath, chain, ...props } : IBreadcrumb) => {

	if (urlBase === "" || urlBase === undefined || urlBase === null)
		return <></>;

	const formatValue = (value: string) => {
		return value.replace(/\b\w/g, (c: string) => c.toUpperCase()).replace("-", " ")
	}
	const dataAttr = getDataAttributes(props);

	const linkTof = tipoOperacionFamilia ? [urlBase, tipoOperacionFamilia] : [urlBase];
	const linkChain = chain ? [...linkTof, chain] : linkTof;
	const linkTpf = tipoPropiedadFamilia ? [...linkChain, tipoPropiedadFamilia] : linkChain;
	const linkRegion = region ? [...linkTpf, regionPath] : linkTpf;
	const linkComuna = comuna ? [...linkRegion, comunaPath] : linkRegion;

	const liArray = [] as IBreadcrumbItem[];
	liArray.push({ link: urlBase, text: "Inicio" });
	tipoOperacionFamilia && liArray.push({ link: linkTof.join("/"), text: tipoOperacionFamilia });
	chain && liArray.push({ link: linkChain.join("/"), text: chain });
	tipoPropiedadFamilia && liArray.push({ link: linkTpf.join("/"), text: tipoPropiedadFamilia });
	region && liArray.push({ link: linkRegion.join("/"), text: region });
	comuna && liArray.push({ link: linkComuna.join("/"), text: comuna });

	const liArrayMobile = [] as IBreadcrumbItem[];
	region && liArrayMobile.push({ link: linkRegion.join("/"), text: region });
	comuna && liArrayMobile.push({ link: linkComuna.join("/"), text: comuna });

	const maxLengthDesktop = 30;
	const maxLengthMobile = 21;

	const drawBreadcrumbItem = (item: IBreadcrumbItem, index: number) => {

		if (!item.text)
			return;

		return (
			<li key={index} className={styles.breadcrumbItem}>
				{
					item.link 
						? <a href={item.link} data-destino={item.link} >{formatValue(item.text)}</a> 
						: (item.text.length > (!isMobile ? maxLengthDesktop : maxLengthMobile) ? <p>{item.text.substring(0, (!isMobile ? maxLengthDesktop : maxLengthMobile))}...</p> : <p>{formatValue(item.text)}</p>)
				}
			</li>);
	};
	
	return (
		<div className={styles.cBreadcrumb}>
			{isMobile 
				? <div className='cDots'><span>...</span></div> 
				: <div id="breadcrumb-home" data-destino={urlBase} {...dataAttr}><a className={styles.icoHome} href={urlBase} ><Icon color="#666" name="Home" size={16} /></a></div>}
			<nav aria-label="breadcrumb" {...dataAttr}>
				<ul className={styles.cBreadcrumItems}>
					{!isMobile ? liArray.map(drawBreadcrumbItem) : liArrayMobile.map(drawBreadcrumbItem)}
				</ul>
			</nav>
		</div>
	)

}